module.exports = __webpack_public_path__ + "img/bec-360px.54e81d46.png";